import React from "react";

export default function Navbar() {
  return (
    <header className="bg-gray-800 md:sticky top-0 z-10">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
      <a href="#about" className="ml-3 text-xl flex items-center">
        <img
          src="./logos/logo.png"
          height={40}
          width={40}
          className="mr-4 rounded-full" // Add a right margin for spacing
          alt="logo"
        />
        <a href="/">
        Vidyasagar S Singadi
          </a>
        
      </a>
        <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700	flex flex-wrap items-center text-base justify-center">
          <a href="/#projects" className="mr-5 hover:text-white">
            Projects
          </a>
          <a href="/#skills" className="mr-5 hover:text-white">
            Skills
          </a>
          <a href="/#contact" className="mr-5 hover:text-white">
            Contact
          </a>
        </nav>
      </div>
    </header>
  );
}


// WEBPACK FOOTER //
// ./src/components/Navbar/index.js